<template>
    <div class="dashboard-wrapper">
        <!-- Sprite ikon (dipakai lewat <use href="#dp-i-...">) -->
        <svg class="dp-sprite" width="0" height="0" aria-hidden="true" focusable="false">
            <defs>
                <symbol id="dp-i-doc" viewBox="0 0 24 24">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" x2="8" y1="13" y2="13" />
                    <line x1="16" x2="8" y1="17" y2="17" />
                </symbol>
                <symbol id="dp-i-card" viewBox="0 0 24 24">
                    <rect width="20" height="14" x="2" y="5" rx="2" />
                    <line x1="2" x2="22" y1="10" y2="10" />
                </symbol>
                <symbol id="dp-i-shield" viewBox="0 0 24 24">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                    <path d="m9 12 2 2 4-4" />
                </symbol>
                <symbol id="dp-i-layers" viewBox="0 0 24 24">
                    <polygon points="12 2 2 7 12 12 22 7 12 2" />
                    <polyline points="2 17 12 22 22 17" />
                    <polyline points="2 12 12 17 22 12" />
                </symbol>
                <symbol id="dp-i-clock" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </symbol>
                <symbol id="dp-i-dollar" viewBox="0 0 24 24">
                    <line x1="12" x2="12" y1="2" y2="22" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </symbol>
                <symbol id="dp-i-file-text" viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" x2="8" y1="13" y2="13" />
                    <line x1="16" x2="8" y1="17" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                </symbol>
                <symbol id="dp-i-arrow-down" viewBox="0 0 24 24">
                    <path d="m19 12-7 7-7-7" />
                    <path d="M12 19V5" />
                </symbol>
                <symbol id="dp-i-arrow-up" viewBox="0 0 24 24">
                    <path d="m5 12 7-7 7 7" />
                    <path d="M12 5v14" />
                </symbol>
                <symbol id="dp-i-chevron-down" viewBox="0 0 24 24">
                    <path d="m6 9 6 6 6-6" />
                </symbol>
                <symbol id="dp-i-menu" viewBox="0 0 24 24">
                    <line x1="3" x2="21" y1="6" y2="6" />
                    <line x1="3" x2="21" y1="12" y2="12" />
                    <line x1="3" x2="21" y1="18" y2="18" />
                </symbol>
                <!-- Ikon aktivitas (urutan 0-5, dipilih menurut urutan data) -->
                 <!-- Perizinan Masuk -->
                <symbol id="dp-i-act-0" viewBox="0 0 24 24">
                    <path d="M12 3v12" />
                    <path d="m7 10 5 5 5-5" />
                    <path d="M5 21h14a2 2 0 0 0 2-2v-3" />
                    <path d="M3 16v3a2 2 0 0 0 2 2" />
                </symbol>
                <!-- Verifikasi Selesai -->
                <symbol id="dp-i-act-1" viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6" />
                    <path d="m8 15 2.5 2.5L16 12" />
                </symbol>
                <!-- Penilaian Teknis -->
                <symbol id="dp-i-act-2" viewBox="0 0 24 24">
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                    <path d="M8 7h8M8 11h8M8 15h5" />
                    <circle cx="17" cy="17" r="2" />
                </symbol>
                <!-- PNBP dibayar -->
                <symbol id="dp-i-act-3" viewBox="0 0 24 24">
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="M3 10h18M7 15h3" />
                    <path d="m15 15 1.5 1.5L20 13" />
                </symbol>
                <!-- Permohonan Ditolak -->
                <symbol id="dp-i-act-4" viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6M9 13l6 6M15 13l-6 6" />
                </symbol>
                <!-- Izin Diterbitkan -->
                <symbol id="dp-i-act-5" viewBox="0 0 24 24">
                    <path d="M6 3h12v18H6z" />
                    <path d="M9 7h6M9 11h6" />
                    <path d="m9 16 2 2 4-4" />
                </symbol>
            </defs>
        </svg>

        <div class="dp-content">
            <!-- ============ BARIS ATAS: 3 KARTU RINGKASAN ============ -->
            <section class="dp-grid-3" aria-label="Ringkasan Utama">
                <!-- 1. Total Permohonan Masuk -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div class="dp-card-title">Total Permohonan Masuk</div>
                        <div class="dp-pnbp-select" title="Filter realisasi PNBP akumulatif hingga bulan yang dipilih">
                            <select v-model="selectedBulanCard1" @change="loadPermohonanMasuk"
                                aria-label="Filter periode akumulatif PNBP">
                                <option value="" disabled>Pilih Bulan</option>
                                <option value="0">Semua Bulan</option>
                                <option v-for="(bulan, index) in listBulan" :key="index" :value="bulan.id">
                                    {{ bulan.nama }}
                                </option>
                            </select>
                            <span class="dp-pnbp-select-arrow">
                                <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                    <use href="#dp-i-chevron-down" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div class="dp-metric-row">
                        <div class="dp-metric-left">
                            <div class="dp-metric-icon dp-metric-icon--blue">
                                <svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-doc" />
                                </svg>
                            </div>
                            <div class="dp-metric-value-wrap">
                                <div class="dp-metric">{{ dataPermohonan.jumlah_sekarang || 0 }}</div>
                                <span class="dp-metric-sub"
                                    :class="dataPermohonan.selisih < 0 ? 'dp-metric-sub--negative' : 'dp-metric-sub--positive'">
                                    <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                        <use
                                            :href="dataPermohonan.selisih < 0 ? '#dp-i-arrow-down' : '#dp-i-arrow-up'" />
                                    </svg>
                                    {{ dataPermohonan.selisih || 0 }}% vs periode lalu
                                </span>
                            </div>
                        </div>

                        <!-- Donut mini (SVG), segmen dihitung di mixin dari permohonanDonutSeries -->
                        <div class="dp-mini-donut" role="img"
                            :aria-label="'Komposisi ' + (dataPermohonan.jumlah_sekarang || 0) + ' permohonan: Berusaha ' + (permohonanDonutSeries[0] || 0) + ', Pemerintah ' + (permohonanDonutSeries[2] || 0) + ', Swasta ' + (permohonanDonutSeries[1] || 0)"
                            :title="'Berusaha ' + (permohonanDonutSeries[0] || 0) + ' · Pemerintah ' + (permohonanDonutSeries[2] || 0) + ' · Swasta ' + (permohonanDonutSeries[1] || 0)">
                            <svg viewBox="0 0 36 36" aria-hidden="true">
                                <circle class="dp-donut-bg" cx="18" cy="18" r="15" />
                                <template v-for="seg in dpPermohonanSegments">
                                    <circle v-if="seg.visible" :key="seg.key" class="dp-donut-bar" :class="seg.cls"
                                        pathLength="100" :stroke-dasharray="seg.dash" :stroke-dashoffset="seg.offset"
                                        cx="18" cy="18" r="15" />
                                </template>
                            </svg>
                            <span class="dp-donut-center">
                                <span class="dp-donut-val">{{ dataPermohonan.jumlah_sekarang || 0 }}</span>
                                <span class="dp-donut-sub">Total</span>
                            </span>
                        </div>
                    </div>

                    <div class="dp-segment-row">
                        <button type="button" class="dp-segment" @click="openDetailModal('Berusaha', 0)">
                            <span class="dp-segment-label"><span class="dp-dot dp-dot--blue"></span> Berusaha</span>
                            <strong>{{ permohonanDonutSeries[0] || 0 }}</strong>
                            <span class="dp-link-btn">Lihat detail ›</span>
                        </button>
                        <button type="button" class="dp-segment" @click="openDetailModal('Pemerintah', 2)">
                            <span class="dp-segment-label"><span class="dp-dot dp-dot--green"></span> Pemerintah</span>
                            <strong>{{ permohonanDonutSeries[2] || 0 }}</strong>
                            <span class="dp-link-btn">Lihat detail ›</span>
                        </button>
                        <button type="button" class="dp-segment" @click="openDetailModal('Swasta', 1)">
                            <span class="dp-segment-label"><span class="dp-dot dp-dot--cyan"></span> Swasta</span>
                            <strong>{{ permohonanDonutSeries[1] || 0 }}</strong>
                            <span class="dp-link-btn">Lihat detail ›</span>
                        </button>
                    </div>
                </article>

                <!-- 2. Total PNBP Masuk -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div class="dp-card-title">Total PNBP</div>

                        <!-- Filter bulan akumulatif -->
                        <div class="dp-pnbp-select" title="Filter realisasi PNBP akumulatif hingga bulan yang dipilih">
                            <select v-model="selectedBulanCard2" @change="loadDataPNBPNew"
                                aria-label="Filter periode akumulatif PNBP">
                                <option value="" disabled>Pilih Bulan</option>
                                <option v-for="(bulan, index) in listBulan" :key="index" :value="bulan.id">
                                    s.d. {{ bulan.nama }}
                                </option>
                            </select>
                            <span class="dp-pnbp-select-arrow">
                                <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                    <use href="#dp-i-chevron-down" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div class="dp-metric-row">
                        <div class="dp-metric-left">
                            <div class="dp-metric-icon dp-metric-icon--purple">
                                <svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-card" />
                                </svg>
                            </div>
                            <div class="dp-metric-value-wrap">
                                <div class="dp-metric">
                                    Rp {{ dataPermohonanCard2.jumlah_sekarang_teks?.angka }}
                                    {{ dataPermohonanCard2.jumlah_sekarang_teks?.satuan }}
                                </div>
                                <span class="dp-metric-sub"
                                    :class="dataPermohonanCard2.selisih < 0 ? 'dp-metric-sub--negative' : 'dp-metric-sub--positive'">
                                    <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                        <use
                                            :href="dataPermohonanCard2.selisih < 0 ? '#dp-i-arrow-down' : '#dp-i-arrow-up'" />
                                    </svg>
                                    {{ dataPermohonanCard2.selisih }}% dari periode sebelumnya
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="dp-progress-wrap">
                        <div class="dp-progress-label">
                            <span>Pencapaian target</span>
                            <b>{{ dataPermohonanCard2.target_persen }}%</b>
                        </div>
                        <div class="dp-progress"><span :style="{ width: progressWidth }"></span></div>
                    </div>

                    <div class="dp-card-foot">
                        <span class="dp-small dp-muted">
                            Target periode Rp {{ dataPermohonanCard2.target_teks?.angka }} {{
                            dataPermohonanCard2.target_teks?.satuan }}
                        </span>
                        <button type="button" class="dp-link-btn" @click="openDetailPNBPMasuk(true)">Lihat Detail
                            ›</button>
                    </div>
                </article>

                <!-- 3. Total Izin Terbit -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div class="dp-card-title">Total Izin Terbit</div>
                        <div class="dp-pnbp-select" title="Filter realisasi PNBP akumulatif hingga bulan yang dipilih">
                            <select v-model="selectedBulanCard3" @change="loadPermohonanIzinTerbit"
                                aria-label="Filter periode akumulatif PNBP">
                                <option value="" disabled>Pilih Bulan</option>
                                <option value="0">Semua Bulan</option>
                                <option v-for="(bulan, index) in listBulan" :key="index" :value="bulan.id">
                                    {{ bulan.nama }}
                                </option>
                            </select>
                            <span class="dp-pnbp-select-arrow">
                                <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                    <use href="#dp-i-chevron-down" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div class="dp-metric-row">
                        <div class="dp-metric-left">
                            <div class="dp-metric-icon dp-metric-icon--green">
                                <svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-shield" />
                                </svg>
                            </div>
                            <div class="dp-metric-value-wrap">
                                <div class="dp-metric">{{ dataPermohonanCard3.jumlah_sekarang }}</div>
                                <span class="dp-metric-sub"
                                    :class="dataPermohonanCard3.selisih < 0 ? 'dp-metric-sub--negative' : 'dp-metric-sub--positive'">
                                    <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                        <use
                                            :href="dataPermohonanCard3.selisih < 0 ? '#dp-i-arrow-down' : '#dp-i-arrow-up'" />
                                    </svg>
                                    {{ dataPermohonanCard3.selisih }}% vs periode lalu
                                </span>
                            </div>
                        </div>

                        <!-- Donut mini (SVG), persen dari gaugeSeries[0] -->
                        <div class="dp-mini-donut" role="img" :aria-label="'Capaian ' + dpIzinPercent + ' persen'"
                            :title="'Capaian ' + dpIzinPercent + '%'">
                            <svg viewBox="0 0 36 36" aria-hidden="true">
                                <circle class="dp-donut-bg" cx="18" cy="18" r="15" />
                                <circle v-if="dpIzinPercent > 0" class="dp-donut-bar dp-donut-bar--green"
                                    pathLength="100" :stroke-dasharray="dpIzinPercent + ' ' + (100 - dpIzinPercent)"
                                    stroke-dashoffset="0" cx="18" cy="18" r="15" />
                            </svg>
                            <span class="dp-donut-center dp-donut-center--single">{{ dpIzinPercent }}%</span>
                        </div>
                    </div>

                    <div class="dp-segment-row dp-segment-row--2">
                        <button type="button" class="dp-segment" @click="openDetailPenerbitanBerusaha(true)">
                            <span class="dp-segment-label"><span class="dp-dot dp-dot--blue"></span> Berusaha</span>
                            <strong>{{ dataPermohonanCard3.jumlah_berusaha_sekarang || 0 }}</strong>
                            <span class="dp-link-btn">Lihat ›</span>
                        </button>
                        <button type="button" class="dp-segment" @click="openDetailPenerbitanNonberusaha(true)">
                            <span class="dp-segment-label"><span class="dp-dot dp-dot--cyan"></span> Non-Berusaha</span>
                            <strong>{{ dataPermohonanCard3.jumlah_nonberusaha_sekarang || 0 }}</strong>
                            <span class="dp-link-btn">Lihat ›</span>
                        </button>
                    </div>
                </article>
            </section>

            <!-- ============ ALUR PROSES BISNIS PERIZINAN ============ -->
            <section class="dp-card dp-process-card">
                <div class="dp-process-head">
                    <div>
                        <div class="dp-card-title">
                            <span class="dp-card-title-icon"><svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-layers" />
                                </svg></span>
                            Alur Proses Bisnis Perizinan
                        </div>
                        <div class="dp-desc">Monitoring pergerakan permohonan dari verifikasi dokumen hingga penerbitan
                            KKPRL</div>
                    </div>
                    <div>
                    <div class="dp-conversion-badge m-1">
                        Tingkat Konversi: <strong>{{ dataPermohonanAlurProsesBisnis.conversion_rate }}%</strong>
                        <span class="info-circle-icon ms-1" v-b-tooltip.hover title="Rasio KKPRL terbit terhadap total permohonan masuk">
            <i class="fa fa-info"></i>
        </span>
                    </div>
                    <div class="dp-pnbp-select" title="Filter realisasi PNBP akumulatif hingga bulan yang dipilih">
                            <select v-model="selectedBulanAlurBisnis" @change="loadPermohonanAlurProsesBisnis"
                                aria-label="Filter periode akumulatif PNBP">
                                <option value="" disabled>Pilih Bulan</option>
                                <option value="0">Semua Bulan</option>
                                <option v-for="(bulan, index) in listBulan" :key="index" :value="bulan.id">
                                    {{ bulan.nama }}
                                </option>
                            </select>
                            <span class="dp-pnbp-select-arrow">
                                <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                    <use href="#dp-i-chevron-down" />
                                </svg>
                            </span>
                        </div>
                        </div>
                </div>

                <div class="dp-stages">
                    <!-- Tahap 1 -->
                    <article class="dp-stage" style="--dp-stage-color: #0879df" role="button" tabindex="0"
                        title="Klik untuk melihat detail Verifikasi Dokumen"
                        @click="openProsesBisnisPerizinan(true, 'Verifikasi Dokumen')"
                        @keydown.enter.self="openProsesBisnisPerizinan(true, 'Verifikasi Dokumen')">
                        <div class="dp-stage-top">
                            <span class="dp-stage-num">01</span>
                            <span class="dp-stage-step">Tahap 1</span>
                        </div>
                        <h3>Verifikasi Dokumen</h3>
                        <div class="dp-count-wrap">
                            <div class="dp-count">
                                {{ dataPermohonanAlurProsesBisnis.verifikasi_dokumen?.jumlah_permohonan || 0 }}
                                <span class="dp-count-label">Total masuk</span>
                            </div>
                        </div>
                        <div class="dp-stage-progress" :class="{ 'is-selected': dpSelectedStage === 0 }" role="button"
                            tabindex="0" :aria-label="'Progress Verifikasi Dokumen ' + dpStagePercents[0] + '%'"
                            @click.stop="dpToggleStage(0)" @keydown.enter.stop.prevent="dpToggleStage(0)"
                            @keydown.space.stop.prevent="dpToggleStage(0)">
                            <span :style="{ width: dpStagePercents[0] + '%' }"></span>
                        </div>
                        <div class="dp-stage-progress-info" :class="{ 'is-shown': dpSelectedStage === 0 }" role="status"
                            aria-live="polite">
                            <span>Progress tahap</span><strong>{{ dpStagePercents[0] }}%</strong>
                        </div>
                        <div class="dp-stage-details">
                            
                            <div class="dp-detail">
                                <span>Dalam Proses</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.verifikasi_dokumen?.jumlah_diproses || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Perbaikan Persyaratan</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.verifikasi_dokumen?.jumlah_perbaikan || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Dokumen Lengkap & Diterima</span>
                                <b class="is-green">{{
                                    dataPermohonanAlurProsesBisnis.verifikasi_dokumen?.jumlah_diterima || 0
                                    }}</b>
                            </div>
                        </div>
                    </article>

                    <!-- Tahap 2 -->
                    <article class="dp-stage" style="--dp-stage-color: #06b6d4" role="button" tabindex="0"
                        title="Klik untuk melihat detail Penjadwalan"
                        @click="openProsesBisnisPerizinan(true, 'Penjadwalan')"
                        @keydown.enter.self="openProsesBisnisPerizinan(true, 'Penjadwalan')">
                        <div class="dp-stage-top">
                            <span class="dp-stage-num">02</span>
                            <span class="dp-stage-step">Tahap 2</span>
                        </div>
                        <h3>Penjadwalan</h3>
                        <div class="dp-count-wrap">
                            <div class="dp-count">
                                {{ dataPermohonanAlurProsesBisnis.penjadwalan?.jumlah_diterima || 0 }}
                                <span class="dp-count-label">Dokumen diterima</span>
                            </div>
                        </div>
                        <div class="dp-stage-progress" :class="{ 'is-selected': dpSelectedStage === 1 }" role="button"
                            tabindex="0" :aria-label="'Progress Penjadwalan ' + dpStagePercents[1] + '%'"
                            @click.stop="dpToggleStage(1)" @keydown.enter.stop.prevent="dpToggleStage(1)"
                            @keydown.space.stop.prevent="dpToggleStage(1)">
                            <span :style="{ width: dpStagePercents[1] + '%' }"></span>
                        </div>
                        <div class="dp-stage-progress-info" :class="{ 'is-shown': dpSelectedStage === 1 }" role="status"
                            aria-live="polite">
                            <span>Progress tahap</span><strong>{{ dpStagePercents[1] }}%</strong>
                        </div>
                        <div class="dp-stage-details">
                            <div class="dp-detail">
                                <span>Dalam antrean</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.penjadwalan?.jumlah_dalam_antrean || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Sudah terjadwal</span>
                                <b class="is-green">{{
                                    dataPermohonanAlurProsesBisnis.penjadwalan?.jumlah_sudah_terjadwal || 0
                                    }}</b>
                            </div>
                        </div>
                    </article>

                    <!-- Tahap 3 -->
                    <article class="dp-stage" style="--dp-stage-color: #7043d2" role="button" tabindex="0"
                        title="Klik untuk melihat detail Penilaian Teknis"
                        @click="openProsesBisnisPerizinan(true, 'Penilaian Teknis')"
                        @keydown.enter.self="openProsesBisnisPerizinan(true, 'Penilaian Teknis')">
                        <div class="dp-stage-top">
                            <span class="dp-stage-num">03</span>
                            <span class="dp-stage-step">Tahap 3</span>
                        </div>
                        <h3>Penilaian Teknis</h3>
                        <div class="dp-count-wrap">
                            <div class="dp-count">
                                {{ dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_sudah_terjadwal || 0 }}
                                <span class="dp-count-label">Sudah terjadwal</span>
                            </div>
                        </div>
                        <div class="dp-stage-progress" :class="{ 'is-selected': dpSelectedStage === 2 }" role="button"
                            tabindex="0" :aria-label="'Progress Penilaian Teknis ' + dpStagePercents[2] + '%'"
                            @click.stop="dpToggleStage(2)" @keydown.enter.stop.prevent="dpToggleStage(2)"
                            @keydown.space.stop.prevent="dpToggleStage(2)">
                            <span :style="{ width: dpStagePercents[2] + '%' }"></span>
                        </div>
                        <div class="dp-stage-progress-info" :class="{ 'is-shown': dpSelectedStage === 2 }" role="status"
                            aria-live="polite">
                            <span>Progress tahap</span><strong>{{ dpStagePercents[2] }}%</strong>
                        </div>
                        <div class="dp-stage-details">
                            <div class="dp-detail">
                                <span>Dalam Penilaian</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_sedang_penilaian || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Disetujui dengan catatan</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_setuju_dengan_catatan || 0
                                    }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Disetujui</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_setuju_dengan_catatan || 0
                                    }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Ditolak</span>
                                <b class="is-red">{{ dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_ditolak || 0
                                    }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Diterima</span>
                                <b class="is-green">{{
                                    dataPermohonanAlurProsesBisnis.status_pentek?.jumlah_sudah_terjadwal || 0
                                    }}</b>
                            </div>
                        </div>
                    </article>

                    <!-- Tahap 4 -->
                    <article class="dp-stage" style="--dp-stage-color: #f59e0b" role="button" tabindex="0"
                        title="Klik untuk melihat detail Pembayaran PNBP"
                        @click="openProsesBisnisPerizinan(true, 'Pembayaran PNBP')"
                        @keydown.enter.self="openProsesBisnisPerizinan(true, 'Pembayaran PNBP')">
                        <div class="dp-stage-top">
                            <span class="dp-stage-num">04</span>
                            <span class="dp-stage-step">Tahap 4</span>
                        </div>
                        <h3>Pembayaran PNBP</h3>
                        <div class="dp-count-wrap">
                            <div class="dp-count">
                                {{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_diterima || 0 }}
                                <span class="dp-count-label">Hasil diterima</span>
                            </div>
                        </div>
                        <div class="dp-stage-progress" :class="{ 'is-selected': dpSelectedStage === 3 }" role="button"
                            tabindex="0" :aria-label="'Progress Pembayaran PNBP ' + dpStagePercents[3] + '%'"
                            @click.stop="dpToggleStage(3)" @keydown.enter.stop.prevent="dpToggleStage(3)"
                            @keydown.space.stop.prevent="dpToggleStage(3)">
                            <span :style="{ width: dpStagePercents[3] + '%' }"></span>
                        </div>
                        <div class="dp-stage-progress-info" :class="{ 'is-shown': dpSelectedStage === 3 }" role="status"
                            aria-live="polite">
                            <span>Progress tahap</span><strong>{{ dpStagePercents[3] }}%</strong>
                        </div>
                        <div class="dp-stage-details">
                            
                            <div class="dp-detail">
                                <span>Menunggu Tagihan</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_belum_tertagih || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Belum bayar</span>
                                <b class="is-red">{{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_belum_bayar || 0
                                    }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Bebas Tarif PNBP</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_belum_bayar || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Pembayaran Terverikasi</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_sudah_bayar ||
                                    0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Proses Penerbitan</span>
                                <b class="is-green">{{ dataPermohonanAlurProsesBisnis.status_pnbp?.jumlah_sudah_bayar ||
                                    0 }}</b>
                            </div>
                        </div>
                    </article>

                    <!-- Tahap 5 -->
                    <article class="dp-stage" style="--dp-stage-color: #10b981" role="button" tabindex="0"
                        title="Klik untuk melihat detail Penerbitan"
                        @click="openProsesBisnisPerizinan(true, 'Penerbitan')"
                        @keydown.enter.self="openProsesBisnisPerizinan(true, 'Penerbitan')">
                        <div class="dp-stage-top">
                            <span class="dp-stage-num">05</span>
                            <span class="dp-stage-step">Tahap 5</span>
                        </div>
                        <h3>Penerbitan</h3>
                        <div class="dp-count-wrap">
                            <div class="dp-count">
                                {{ dataPermohonanAlurProsesBisnis.penerbitan?.jumlah_proses || 0 }}
                                <span class="dp-count-label">Jumlah Proses</span>
                            </div>
                        </div>
                        <div class="dp-stage-progress" :class="{ 'is-selected': dpSelectedStage === 4 }" role="button"
                            tabindex="0" :aria-label="'Progress Penerbitan ' + dpStagePercents[4] + '%'"
                            @click.stop="dpToggleStage(4)" @keydown.enter.stop.prevent="dpToggleStage(4)"
                            @keydown.space.stop.prevent="dpToggleStage(4)">
                            <span :style="{ width: dpStagePercents[4] + '%' }"></span>
                        </div>
                        <div class="dp-stage-progress-info" :class="{ 'is-shown': dpSelectedStage === 4 }" role="status"
                            aria-live="polite">
                            <span>Progress tahap</span><strong>{{ dpStagePercents[4] }}%</strong>
                        </div>
                        <div class="dp-stage-details">
                            <div class="dp-detail">
                                <span>Proses MKP</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.penerbitan?.jumlah_proses_mkp || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>Proses OSS</span>
                                <b>{{ dataPermohonanAlurProsesBisnis.penerbitan?.jumlah_proses_oss || 0 }}</b>
                            </div>
                            <div class="dp-detail">
                                <span>KKPRL Terbit</span>
                                <b class="is-green">{{ dataPermohonanAlurProsesBisnis.penerbitan?.jumlah_sudah_terbit ||
                                    0 }}</b>
                            </div>
                        </div>
                    </article>
                </div>
            </section>

            <!-- ============ AKTIVITAS REAL TIME & PNBP REVENUE ============ -->
            <section class="dp-two-col">
                <!-- Aktivitas real time -->
                <article class="dp-card">
                    <div class="dp-card-header">

                        <div class="dp-card-title">
                            <span class="dp-card-title-icon"><svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-clock" />
                                </svg></span>
                            Aktivitas Terkini
                        </div>
                        <span class="dp-live-pill"><span class="dp-live-dot"></span>Live</span>
                    </div>
                    <div class="dp-desc">Pembaruan otomatis sistem hari ini, {{ currentTime }} WIB</div>

                    <div class="dp-activity-list">
                        <div v-for="(item, idx) in dataPermohonanAktivitas" :key="idx" class="dp-activity">
        <div class="dp-activity-left">
            <!-- Menggunakan fungsi getIconConfig untuk menentukan ID ikon dan kelas warna -->
            <span class="dp-activity-icon" :class="getIconConfig(item.label).class" aria-hidden="true">
                <svg class="dp-ic" aria-hidden="true">
                    <use :href="getIconConfig(item.label).href" />
                </svg>
            </span>
            <span>{{ item.label }}</span>
        </div>
        <span class="dp-badge-count" :class="{ 'is-active': item.total > 0 }">
            +{{ item.total }}
        </span>
    </div>
                    </div>
                </article>

                <!-- PNBP revenue (grafik apexchart tetap dipakai) -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div>
                            <div class="dp-card-title">
                                <span class="dp-card-title-icon"><svg class="dp-ic" aria-hidden="true">
                                        <use href="#dp-i-dollar" />
                                    </svg></span>
                                PNBP Revenue
                            </div>
                            <div class="dp-desc">Realisasi perolehan PNBP per bulan tahun anggaran berjalan</div>
                        </div>

                        <b-dropdown variant="light" toggle-class="dp-icon-btn" no-caret right>
                            <template #button-content>
                                <svg class="dp-ic" aria-label="Menu unduh">
                                    <use href="#dp-i-menu" />
                                </svg>
                            </template>

                            <b-dropdown-item @click="downloadPNG" style="width: 210px !important;">
                                <i class="fa fa-file-image-o me-2"></i> Download PNG
                            </b-dropdown-item>

                            <b-dropdown-item @click="exportToExcel" style="width: 210px !important;">
                                <i class="fa fa-file-excel-o me-2"></i> Download Excel (.xlsx)
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <div class="dp-chart-box">
                        <apexchart ref="PNBPRevenue" type="bar" height="300" :options="barChartOptions"
                            :series="barChartSeries">
                        </apexchart>
                    </div>
                </article>

                <!-- Blok SLA & Performa yang dinonaktifkan pada versi lama tidak dibawa. -->
            </section>

            <!-- ============ SEBARAN SEKTOR & DISTRIBUSI PROVINSI ============ -->
            <section class="dp-bottom-grid">
                <!-- Sebaran per sektor -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div>
                            <div class="dp-card-title">Sebaran Perizinan Berdasarkan Sektor</div>
                            <div class="dp-desc">Proporsi permohonan per kategori sektor</div>
                        </div>

                        <b-dropdown variant="light" toggle-class="dp-icon-btn" no-caret right>
                            <template #button-content>
                                <svg class="dp-ic" aria-label="Menu unduh">
                                    <use href="#dp-i-menu" />
                                </svg>
                            </template>

                            <b-dropdown-item @click="downloadPNGSektor" style="width: 210px !important;">
                                <i class="fa fa-file-image-o me-2"></i> Download PNG
                            </b-dropdown-item>

                            <b-dropdown-item @click="exportToExcelSektor" style="width: 210px !important;">
                                <i class="fa fa-file-excel-o me-2"></i> Download Excel (.xlsx)
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <div class="dp-sector-layout" ref="ChartSektor">
                        <div class="dp-pie-wrapper">
                            <apexchart type="donut" width="100%" height="100%" :options="sectorDonutOptions"
                                :series="sectorDonutSeries"></apexchart>
                        </div>

                        <div class="dp-legend">
                            <div v-for="(sec, idx) in sectors" :key="idx" class="dp-legend-row">
                                <span class="dp-legend-name">
                                    <span class="dp-legend-dot" :style="{ backgroundColor: sec.color }"></span>
                                    {{ sec.name }}
                                </span>
                                <span class="dp-legend-count">{{ sec.count }}</span>
                                <span class="dp-legend-percent">{{ sec.pct }}%</span>
                                <div class="dp-legend-line">
                                    <span :style="{ width: sec.pct + '%', backgroundColor: sec.color }"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>

                <!-- Distribusi per provinsi -->
                <article class="dp-card">
                    <div class="dp-card-header">
                        <div>
                            <div class="dp-card-title">Distribusi Permohonan per Provinsi</div>
                            <div class="dp-desc">
                                {{ selectedLimit === 'all' ? 'Seluruh provinsi' : '6 provinsi dengan volume permohonan tertinggi' }}
                            </div>
                        </div>

                        <div class="dp-card-actions">
                            <div class="dp-select-wrap">
                                <select v-model="selectedLimit" @change="loadDataPermohonanProvinsi" class="dp-select"
                                    aria-label="Jumlah provinsi yang ditampilkan">
                                    <option value="top">Top 6</option>
                                    <option value="all">Semua (All)</option>
                                </select>
                                <span class="dp-select-arrow">
                                    <svg class="dp-ic dp-ic--xs" aria-hidden="true">
                                        <use href="#dp-i-chevron-down" />
                                    </svg>
                                </span>
                            </div>

                            <b-dropdown variant="light" toggle-class="dp-icon-btn" no-caret right>
                                <template #button-content>
                                    <svg class="dp-ic" aria-label="Menu unduh">
                                        <use href="#dp-i-menu" />
                                    </svg>
                                </template>

                                <b-dropdown-item @click="downloadPNGDistribusiProvinsi"
                                    style="width: 210px !important;">
                                    <i class="fa fa-file-image-o me-2"></i> Download PNG
                                </b-dropdown-item>

                                <b-dropdown-item @click="exportToExcelDistribusiProvinsi"
                                    style="width: 210px !important;">
                                    <i class="fa fa-file-excel-o me-2"></i> Download Excel (.xlsx)
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                    <div class="dp-province-list" ref="ChartDistribusiProvinsi">
                        <div v-for="(prov, idx) in provinces" :key="idx" class="dp-province">
                            <span class="dp-rank">{{ String(idx + 1).padStart(2, '0') }}</span>
                            <span class="dp-name" :title="prov.name">{{ prov.name }}</span>
                            <div class="dp-track"><span :style="{ width: prov.pct + '%' }"></span></div>
                            <span class="dp-number">{{ prov.val }}</span>
                        </div>
                    </div>
                </article>
            </section>

            <!-- ============ PERMOHONAN PKPN ============ -->
            <section class="dp-card dp-table-card">
                <div class="dp-table-head">
                    <div>
                        <div class="dp-card-title">
                            <span class="dp-card-title-icon"><svg class="dp-ic" aria-hidden="true">
                                    <use href="#dp-i-file-text" />
                                </svg></span>
                            Permohonan PKPN
                        </div>
                        <div class="dp-desc">Daftar permohonan PKPN (Program Kerja Prioritas Nasional)</div>
                    </div>
                </div>

                <div class="mt-3">
                    <TabelPermohonanPKPN :data-permohonan="dataGabungan" :is-loading="isLoading"
                        @on-detail="handleDetail" />
                </div>

                <!-- <b-tabs v-model="activeTab" pills class="dp-switch-tabs" active-nav-item-class="dp-switch-active"
          content-class="mt-0" @input="handleTabChange">
          <b-tab active style="padding:0px !important">
            <template #title>
              Berusaha <span class="dp-switch-count">{{ totalBerusaha }}</span>
            </template>

            <div class="dp-table-scope">
              <TabelPermohonanPKPN :data-permohonan="dataBerusaha" :is-loading="isLoading" @on-detail="handleDetail" />
            </div>
          </b-tab>

          <b-tab style="padding:0px !important">
            <template #title>
              Non Berusaha <span class="dp-switch-count">{{ totalNonBerusaha }}</span>
            </template>

            <div class="dp-table-scope">
              <TabelPermohonanPKPN :data-permohonan="dataNonBerusaha" :is-loading="isLoading"
                @on-detail="handleDetail" />
            </div>
          </b-tab>
        </b-tabs> -->
            </section>
        </div>

        <!-- Modal & panel detail (tidak diubah) -->
        <DetailModalDashboard ref="detailModalRef" :filter="filterTahun" />
        <DetailPenerbitanSudahBayar :show="showDetailPenerbitanSudahBayar" @close="openDetailPNBPMasuk"
            :filter-tahun="filterTahun" />

        <DetailPenerbitanBerusaha :show="showDetailPenerbitanBerusaha" @close="openDetailPenerbitanBerusaha"
            :filter-tahun="filterTahun" />
        <DetailPenerbitanNonberusaha :show="showDetailPenerbitanNonberusaha" @close="openDetailPenerbitanNonberusaha"
            :filter-tahun="filterTahun" />

        <DetailAlurBisnisPerizinan :show="showDetailProsesBisnisPerizinan" @close="openProsesBisnisPerizinan"
            :filter-tahun="filterTahun" :jenisTahap="jenisTahap" />
    </div>
</template>

<script>
import axios from 'axios';
import { formatIDR } from '../../helper/helpernew';
import DetailModalDashboard from './components/Modal/DetailModalDashboardPermohonan.vue';
import DetailPenerbitanSudahBayar from './components/Modal/DetailPenerbitanSudahBayar/DetailPenerbitanSudahBayar.vue';
import DetailPenerbitanBerusaha from './components/Modal/DetailPenerbitanBerusaha.vue';
import DetailPenerbitanNonberusaha from './components/Modal/DetailPenerbitanNonberusaha.vue';
import DetailAlurBisnisPerizinan from './components/Modal/DetailAlurBisnisPerizinan/DetailAlurBisnisPerizinan.vue';
import TabelPermohonanPKPN from './components/Perizinan/TabelPermohonanPKPN.vue';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';

// ---------------------------------------------------------------------------
// Helper tampilan dashboard (desain baru)
// ---------------------------------------------------------------------------
const dpNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

const dpEscape = (v) =>
    String(v == null ? '' : v)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

// Label sumbu Y ringkas: 25000000000 -> "Rp 25 M", 1500000 -> "Rp 1,5 Jt".
function formatRpShort(value) {
    const v = dpNum(value);
    const abs = Math.abs(v);
    const units = [
        [1e12, 'T'],
        [1e9, 'M'],
        [1e6, 'Jt'],
        [1e3, 'Rb'],
    ];
    for (const [size, label] of units) {
        if (abs >= size) {
            const n = Math.round((v / size) * 10) / 10;
            return 'Rp ' + String(n).replace('.', ',') + ' ' + label;
        }
    }
    return 'Rp ' + Math.round(v);
}

// Tooltip grafik PNBP (gelap, sama seperti mock): bulan, nilai bulanan, nilai kumulatif.
function pnbpTooltip({ series, dataPointIndex, w }) {
    const g = (w && w.globals) || {};
    const month =
        (g.categoryLabels && g.categoryLabels[dataPointIndex]) ||
        (g.labels && g.labels[dataPointIndex]) ||
        '';
    const monthly = series && series[0] ? series[0][dataPointIndex] : 0;
    const cumulative = series && series[1] ? series[1][dataPointIndex] : 0;
    return (
        '<div class="dp-tt">' +
        '<span class="dp-tt-month">' + dpEscape(month) + '</span>' +
        '<strong class="dp-tt-amount">' + dpEscape(formatIDR(monthly)) + '</strong>' +
        '<small class="dp-tt-cum">Kumulatif: ' + dpEscape(formatIDR(cumulative)) + '</small>' +
        '</div>'
    );
}

// Jika seluruh data PNBP masih 0, beri skala tetap supaya label sumbu tidak "Rp 0" semua.
const PNBP_EMPTY_AXIS_MAX = 1000000000;

// Palet sektor mengikuti mock; "Lainnya" selalu abu-abu. Sektor di atas 7 memakai warna tambahan.
const SECTOR_PALETTE = [
    '#0879df', '#06b6d4', '#10b981', '#7043d2', '#8b5cf6', '#f59e0b', '#3b82f6',
    '#14b8a6', '#ec4899', '#ef4444', '#84cc16', '#f97316',
];
const SECTOR_OTHER_COLOR = '#94a3b8';

function buildSectorColors(labels) {
    let n = 0;
    return (labels || []).map((label) =>
        /^lainnya$/i.test(String(label).trim())
            ? SECTOR_OTHER_COLOR
            : SECTOR_PALETTE[n++ % SECTOR_PALETTE.length]
    );
}

export default {
    name: 'DashboardPerizinanApex',
    props: ['filterTahun'],
    components: { DetailModalDashboard, DetailPenerbitanSudahBayar, DetailPenerbitanBerusaha, DetailPenerbitanNonberusaha, DetailAlurBisnisPerizinan, TabelPermohonanPKPN },
    data() {
        return {
            baseapi: localStorage.getItem('baseapi'),
            user: JSON.parse(localStorage.getItem('user')),
            currentTime: '10:42',
            showDetailPenerbitanSudahBayar: false,
            showDetailPenerbitanBerusaha: false,
            showDetailPenerbitanNonberusaha: false,
            showDetailProsesBisnisPerizinan: false,
            liveActivities: [
                { label: 'Perizinan Masuk', count: 2 },
                { label: 'Verifikasi Selesai', count: 2 },
                { label: 'Penilaian Teknis', count: 3 },
                { label: 'Izin Diterbitkan', count: 2 },
                { label: 'PNBP Dibayar', count: 1 },
                { label: 'Permohonan Ditolak', count: 0 }
            ],
            dataPermohonan: {},
            dataPermohonanCard2: {},
            dataPermohonanCard3: {},
            dataPermohonanAlurProsesBisnis: {},
            dataPermohonanAktivitas: {},
            dataPermohonanPNBPRevenue: {},
            dataPermohonanPerizinanSektor: {},
            dataPermohonanPerizinanProvinsi: {},

            // 1. Label & warna kategori kartu "Total Permohonan Masuk".
            //    Donut mini kini SVG (computed dpPermohonanSegments). Objek ini tetap dipakai
            //    openDetailModal() / handleSliceClick() untuk label dan warna pada modal.
            //    Urutan = indeks series: 0 Berusaha, 1 Swasta, 2 Pemerintah.
            permohonanDonutSeries: [],
            permohonanDonutOptions: {
                labels: [],
                colors: ['#0879df', '#06b6d4', '#10b981'],
            },

            // 2. Persen kartu "Total Izin Terbit" (donut mini SVG membaca computed dpIzinPercent)
            gaugeSeries: [0],

            // 3. PNBP per bulan: bar (bulanan) + garis (kumulatif), sumbu Y ganda seperti mock
            barChartSeries: [
                { name: 'Bulanan', type: 'column', data: [] },
                { name: 'Kumulatif', type: 'line', data: [] }
            ],
            barChartOptions: {
                chart: {
                    type: 'line', // grafik campuran: series[0] = column, series[1] = line
                    toolbar: { show: false },
                    zoom: { enabled: false },
                    fontFamily: 'inherit'
                },
                colors: ['#10b981', '#0879df'],
                plotOptions: {
                    bar: {
                        borderRadius: 5,
                        borderRadiusApplication: 'end',
                        columnWidth: '45%'
                    }
                },
                stroke: { width: [0, 2], curve: 'straight' },
                fill: {
                    type: ['gradient', 'solid'],
                    gradient: {
                        shade: 'light',
                        type: 'vertical',
                        gradientToColors: ['#059669'],
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                markers: {
                    size: [0, 4],
                    colors: ['#ffffff', '#ffffff'],
                    strokeColors: ['#10b981', '#0879df'],
                    strokeWidth: 2,
                    hover: { size: 6 }
                },
                dataLabels: { enabled: false },
                legend: {
                    show: true,
                    position: 'top',
                    horizontalAlign: 'left',
                    fontSize: '11px',
                    fontFamily: 'inherit',
                    labels: { colors: '#64748b' },
                    markers: { width: 10, height: 10, radius: 2 },
                    itemMargin: { horizontal: 10 }
                },
                xaxis: {
                    categories: ['JAN', 'FEB', 'MAR', 'APR', 'MEI', 'JUN', 'JUL', 'AGU', 'SEP', 'OKT', 'NOV', 'DES'],
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                    tooltip: { enabled: false },
                    labels: { style: { fontSize: '10px', colors: '#64748b' } }
                },
                yaxis: [
                    {
                        // kiri: nilai bulanan
                        seriesName: 'Bulanan',
                        min: 0,
                        tickAmount: 4,
                        labels: { formatter: formatRpShort, style: { fontSize: '10px', colors: '#64748b' } }
                    },
                    {
                        // kanan: nilai kumulatif
                        seriesName: 'Kumulatif',
                        opposite: true,
                        min: 0,
                        tickAmount: 4,
                        labels: { formatter: formatRpShort, style: { fontSize: '10px', colors: '#64748b' } }
                    }
                ],
                grid: {
                    borderColor: '#f1f5f9',
                    strokeDashArray: 0,
                    padding: { left: 4, right: 4 }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    custom: pnbpTooltip
                },
            },

            // 4. ApexChart Sector Donut Chart
            sectorDonutSeries: [],
            sectorDonutOptions: {
                chart: { type: 'donut', fontFamily: 'inherit' },
                colors: [],
                labels: [],
                legend: { show: false },
                dataLabels: { enabled: false },
                tooltip: { enabled: true },
                stroke: { width: 2, colors: ['#ffffff'] },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '55%',
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: '11px',
                                    fontWeight: 500,
                                    color: '#64748b',
                                    offsetY: -2,
                                    // nama sektor panjang dipotong agar tidak keluar dari lubang donut
                                    formatter: (val) => (String(val).length > 13 ? String(val).slice(0, 12) + '…' : val)
                                },
                                value: {
                                    show: true,
                                    fontSize: '19px',
                                    fontWeight: 700,
                                    color: '#0f172a',
                                    offsetY: 4,
                                    formatter: (val) => val
                                },
                                total: {
                                    show: true,
                                    label: 'Total Izin',
                                    fontSize: '11px',
                                    fontWeight: 500,
                                    color: '#64748b',
                                    formatter: () => this.dataPermohonanPerizinanSektor.total || 0
                                }
                            }
                        }
                    }
                }
            },

            sectors: [],
            provinces: [],
            jenisTahap: null,
            activeTab: 0,
            isLoading: false,
            dataBerusaha: [],
            dataNonBerusaha: [],
            totalGabungan:0,
            dataGabungan:[],
            totalBerusaha: 0,
            totalNonBerusaha: 0,
            selectedBulanCard1: new Date().getMonth() + 1,
            selectedBulanCard2: new Date().getMonth() + 1,
            selectedBulanCard3: new Date().getMonth() + 1,
            selectedBulanAlurBisnis: new Date().getMonth() + 1,
            listBulan: [
                { id: 1, nama: "Januari" },
                { id: 2, nama: "Februari" },
                { id: 3, nama: "Maret" },
                { id: 4, nama: "April" },
                { id: 5, nama: "Mei" },
                { id: 6, nama: "Juni" },
                { id: 7, nama: "Juli" },
                { id: 8, nama: "Agustus" },
                { id: 9, nama: "September" },
                { id: 10, nama: "Oktober" },
                { id: 11, nama: "November" },
                { id: 12, nama: "Desember" }
            ],
            selectedLimit: 'top',

            // Tahap alur bisnis (0-4) yang info progresnya sedang ditampilkan; null = tidak ada
            dpSelectedStage: null,
        };
    },
    mounted() {
        this.updateClock();
        setInterval(this.updateClock, 60000);
        this.fetchDataPermohonan("all");
    },
    computed: {
        progressWidth() {
            const val = parseFloat(this.dataPermohonanCard2?.target_persen) || 0;
            return Math.min(Math.max(val, 0), 100) + '%';
        },

        /**
         * Segmen donut mini kartu "Total Permohonan Masuk".
         * Urutan gambar = urutan legend: Berusaha (series[0]), Pemerintah (series[2]), Swasta (series[1]).
         */
        dpPermohonanSegments() {
            const s = this.permohonanDonutSeries || [];
            const items = [
                { key: 'berusaha', value: dpNum(s[0]), cls: 'dp-donut-bar--blue' },
                { key: 'pemerintah', value: dpNum(s[2]), cls: 'dp-donut-bar--green' },
                { key: 'swasta', value: dpNum(s[1]), cls: 'dp-donut-bar--cyan' },
            ];
            const total = items.reduce((sum, it) => sum + it.value, 0);
            let acc = 0;
            return items.map((it) => {
                const pct = total > 0 ? (it.value / total) * 100 : 0;
                const seg = {
                    key: it.key,
                    cls: it.cls,
                    visible: pct > 0,
                    dash: pct.toFixed(2) + ' ' + (100 - pct).toFixed(2),
                    offset: (-acc).toFixed(2),
                };
                acc += pct;
                return seg;
            });
        },

        /** Persen pada donut mini kartu "Total Izin Terbit" (gaugeSeries[0], dibatasi 0-100). */
        dpIzinPercent() {
            const v = dpNum((this.gaugeSeries || [])[0]);
            return Math.round(Math.max(0, Math.min(100, v)) * 100) / 100;
        },

        /**
         * Persen progres tiap tahap (indeks 0-4). Rumus sama dengan versi lama
         * (nilai tahap / jumlah_permohonan x 100), tetapi aman dari NaN dan dibulatkan.
         */
        dpStagePercents() {
            const a = this.dataPermohonanAlurProsesBisnis || {};
            const base = dpNum(a.verifikasi_dokumen && a.verifikasi_dokumen.jumlah_permohonan);
            const pct = (n) => (base > 0 ? Math.max(0, Math.min(100, Math.round((dpNum(n) / base) * 100))) : 0);
            return [
                100,
                pct(a.penjadwalan && a.penjadwalan.jumlah_diterima),
                pct(a.status_pentek && a.status_pentek.jumlah_sudah_terjadwal),
                pct(a.status_pnbp && a.status_pnbp.jumlah_diterima),
                pct(a.penerbitan && a.penerbitan.jumlah_proses),
            ];
        }
    },
    methods: {
        /** Klik/Enter/Spasi pada bar progres tahap: tampilkan atau sembunyikan info "Progress tahap". */
        dpToggleStage(index) {
            this.dpSelectedStage = this.dpSelectedStage === index ? null : index;
        },

        updateClock() {
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            this.currentTime = `${hours}:${minutes}`;
        },
        async loadDataPermohonan() {
            this.loadPermohonanMasuk()

            this.loadDataPNBPNew()

            this.loadPermohonanIzinTerbit()

            this.loadPermohonanAlurProsesBisnis()

            try {
                const res5 = await axios.get(
                    `${this.baseapi}api/dashboard/getRealtimeActivity?tahun=${this.filterTahun}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanAktivitas = res5.data.data


            } catch (error) { }

            try {
                const res6 = await axios.get(
                    `${this.baseapi}api/dashboard/getJumlahPNBPperBulan?tahun=${this.filterTahun}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanPNBPRevenue = res6.data.data

                if (this.dataPermohonanPNBPRevenue && this.dataPermohonanPNBPRevenue.series) {
                    // Nilai bulanan (bar) dan akumulasinya (garis), seperti desain baru.
                    const monthly = this.dataPermohonanPNBPRevenue.series.map((v) => dpNum(v));
                    let running = 0;
                    const cumulative = monthly.map((v) => (running += v));
                    const allZero = !cumulative.some((v) => v > 0);

                    this.barChartSeries = [
                        { name: 'Bulanan', type: 'column', data: monthly },
                        { name: 'Kumulatif', type: 'line', data: cumulative }
                    ];

                    // Bila semua nilai masih 0, kunci skala sumbu Y; selain itu biarkan otomatis.
                    const yaxis = this.barChartOptions.yaxis.map((axis) => {
                        const copy = Object.assign({}, axis);
                        delete copy.max;
                        if (allZero) copy.max = PNBP_EMPTY_AXIS_MAX;
                        return copy;
                    });

                    this.barChartOptions = {
                        ...this.barChartOptions,
                        xaxis: {
                            ...this.barChartOptions.xaxis,
                            categories: [...this.dataPermohonanPNBPRevenue.categories]
                        },
                        yaxis
                    };
                }

            } catch (error) { }

            try {
                const res7 = await axios.get(
                    `${this.baseapi}api/dashboard/getPerizinanPerSektor?tahun=${this.filterTahun}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanPerizinanSektor = res7.data.data



                const sektor = this.dataPermohonanPerizinanSektor || {};
                const labels = sektor.label || [];
                const values = sektor.value || [];

                // Warna ditetapkan sekali, dipakai bersama oleh donut dan legend (tidak lagi acak).
                const colors = buildSectorColors(labels);

                this.sectorDonutSeries = [...values];
                this.sectorDonutOptions = {
                    ...this.sectorDonutOptions,
                    labels: [...labels],
                    colors
                };

                const total = sektor.total || 1;

                this.sectors = labels.map((item, index) => {
                    const count = values[index] || 0;
                    const pct = ((count / total) * 100).toFixed(1);

                    return {
                        name: item,
                        count: count,
                        pct: parseFloat(pct),
                        color: colors[index]
                    };
                });

                this.loadDataPermohonanProvinsi();




            } catch (error) { }
        },

        async loadDataPNBPNew() {
            try {
                const res = await axios.get(
                    `${this.baseapi}api/dashboard/getJumlahPNBPNew?tahun=${this.filterTahun}&bulan=${this.selectedBulanCard2}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanCard2 = res.data.data
            } catch (error) { }
        },

        async loadDataPermohonanProvinsi() {
            try {
                const res8 = await axios.get(
                    `${this.baseapi}api/dashboard/getPerizinanPerProvinsi?tahun=${this.filterTahun}&mode=${this.selectedLimit}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanPerizinanProvinsi = res8.data.data


                if (this.dataPermohonanPerizinanProvinsi && this.dataPermohonanPerizinanProvinsi.label && this.dataPermohonanPerizinanProvinsi.value) {
                    // Cari nilai terbesar dari array value (misal: 12) untuk dasar persentase 100%
                    const maxVal = Math.max(...this.dataPermohonanPerizinanProvinsi.value) || 1;

                    this.provinces = this.dataPermohonanPerizinanProvinsi.label.map((item, index) => {
                        const val = this.dataPermohonanPerizinanProvinsi.value[index] || 0;
                        return {
                            name: item,
                            val: val,
                            // Persentase relatif terhadap nilai tertinggi agar bar tidak overflow
                            pct: ((val / maxVal) * 100).toFixed(1)
                        };
                    });
                }



            } catch (error) { }
        },

        async loadPermohonanMasuk() {
            try {
                const res = await axios.get(
                    `${this.baseapi}api/dashboard/getJumlahPermohonanNew?tahun=${this.filterTahun}&bulan=${this.selectedBulanCard1}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonan = res.data.data

                if (this.dataPermohonan.chart && this.dataPermohonan.chart.jumlah) {

                    this.permohonanDonutSeries = this.dataPermohonan.chart.jumlah;

                    this.permohonanDonutOptions = {
                        ...this.permohonanDonutOptions,
                        labels: this.dataPermohonan.chart.label
                    };
                }
            } catch (error) { }
        },

        async loadPermohonanIzinTerbit() {
            try {
                const res3 = await axios.get(
                    `${this.baseapi}api/dashboard/getJumlahIzinTerbit?tahun=${this.filterTahun}&bulan=${this.selectedBulanCard3}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanCard3 = res3.data.data

                if (this.dataPermohonanCard3.completion_rate != null) {
                    // Ganti array utuh agar Vue 2 & ApexChart mendeteksi perubahan
                    this.gaugeSeries = [parseFloat(this.dataPermohonanCard3.completion_rate)];
                }


            } catch (error) { }
        },

        async loadPermohonanAlurProsesBisnis() {
            try {
                const res4 = await axios.get(
                    `${this.baseapi}api/dashboard/getBottleneckAnalysis?tahun=${this.filterTahun}&bulan=${this.selectedBulanAlurBisnis}`,
                    {
                        headers: {
                            Authorization: `Bearer ` + this.user.accessToken,
                        },
                    },
                )
                this.dataPermohonanAlurProsesBisnis = res4.data.data


            } catch (error) { }
        },

        handleSliceClick(config) {
            const dataIndex = config.dataPointIndex
            if (dataIndex === -1 || dataIndex === undefined) return

            const total = this.permohonanDonutSeries.reduce((a, b) => a + b, 0)
            const val = this.permohonanDonutSeries[dataIndex] || 0
            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0

            // Susun objek informasi status yang diklik
            const selectedStatus = {
                label: this.permohonanDonutOptions.labels[dataIndex] || 'N/A',
                value: val,
                percentage: percentage,
                color: this.permohonanDonutOptions.colors[dataIndex] || '#2b6cb0',
                tahun: this.filterTahun,
                filter: this.permohonanDonutOptions.labels[dataIndex] == 'Berusaha' ? '' : this.permohonanDonutOptions.labels[dataIndex] == 'Pemerintah' ? 'tipe_pemohon,=,Pemerintah' : 'tipe_pemohon,=,Swasta'
            }

            // Panggil method showModal di komponen DetailModal
            this.$refs.detailModalRef.showModal(selectedStatus)
        },
        openDetailModal(label, index) {
            const total = this.permohonanDonutSeries.reduce((a, b) => a + b, 0)
            const val = this.permohonanDonutSeries[index] || 0
            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0

            const selectedStatus = {
                label: label,
                value: val,
                percentage: percentage,
                color: this.permohonanDonutOptions.colors[index] || '#2b6cb0',
                tahun: this.filterTahun,
                filter: this.permohonanDonutOptions.labels[index] == 'Berusaha' ? '' : this.permohonanDonutOptions.labels[index] == 'Pemerintah' ? 'tipe_pemohon,=,Pemerintah' : 'tipe_pemohon,=,Swasta'
            }

            // Panggil method showModal milik komponen DetailModal
            if (this.$refs.detailModalRef) {
                this.$refs.detailModalRef.showModal(selectedStatus)
            }
        },
        openDetailPNBPMasuk(val) {
            this.showDetailPenerbitanSudahBayar = val
        },
        openDetailPenerbitanBerusaha(val) {
            this.showDetailPenerbitanBerusaha = val
        },
        openDetailPenerbitanNonberusaha(val) {
            this.showDetailPenerbitanNonberusaha = val
        },
        openProsesBisnisPerizinan(val, jenis) {
            this.showDetailProsesBisnisPerizinan = val
            this.jenisTahap = jenis
        },


        //PKPN
        handleTabChange(tabIndex) {
            const jenis = tabIndex === 0 ? "berusaha" : "non-berusaha";
            if ((jenis === "berusaha") ||
                (jenis === "non-berusaha")) {
                this.fetchDataPermohonan(jenis);
            }
        },

        async fetchDataPermohonan(jenis) {
            this.isLoading = true;
            try {
                const firstDate = `${this.filterTahun}-01-01`;
                const lastDate = `${this.filterTahun}-12-31`;
                const headers = { Authorization: `Bearer ${this.user.accessToken}` };

                // Jika ingin mengambil dan menggabungkan keduanya sekaligus
                if (jenis === 'all' || jenis === 'gabungan') {
                    const [resBerusaha, resNonBerusaha] = await Promise.all([
                        axios.get(
                            `${this.baseapi}api/permohonan?filter=tanggal_pada_permohonan,>=,${firstDate};tanggal_pada_permohonan,<=,${lastDate};is_pkpn,=,true&limit=-1`,
                            { headers }
                        ),
                        axios.get(
                            `${this.baseapi}api/permohonan_nonberusaha?filter=tanggal_permohonan,>=,${firstDate};tanggal_permohonan,<=,${lastDate};is_pkpn,=,true&limit=-1`,
                            { headers }
                        )
                    ]);

                    // Menambahkan field jenis: 'berusaha' pada setiap item data berusaha
                    const dataB = (resBerusaha.data.data || []).map(item => ({
                        ...item,
                        jenis: 'berusaha'
                    }));

                    // Menambahkan field jenis: 'nonberusaha' pada setiap item data non-berusaha
                    const dataNB = (resNonBerusaha.data.data || []).map(item => ({
                        ...item,
                        jenis: 'nonberusaha'
                    }));

                    // Menggabungkan kedua array data menjadi satu
                    this.dataGabungan = [...dataB, ...dataNB];

                    // Menjumlahkan total keseluruhan data
                    const totalB = resBerusaha.data.total || dataB.length;
                    const totalNB = resNonBerusaha.data.total || dataNB.length;
                    this.totalGabungan = totalB + totalNB;

                } else {
                    // Logika standar jika memanggil salah satu jenis saja
                    const endpoint = jenis === 'berusaha' ? 'permohonan' : 'permohonan_nonberusaha';
                    const dateField = jenis === 'berusaha' ? 'tanggal_pada_permohonan' : 'tanggal_permohonan';

                    const response = await axios.get(
                        `${this.baseapi}api/${endpoint}?filter=${dateField},>=,${firstDate};${dateField},<=,${lastDate};is_pkpn,=,true&limit=-1`,
                        { headers }
                    );

                    // Menambahkan field jenis secara dinamis sesuai parameter
                    const processedData = (response.data.data || []).map(item => ({
                        ...item,
                        jenis: jenis
                    }));

                    if (jenis === "berusaha") {
                        this.dataBerusaha = processedData;
                        this.totalBerusaha = response.data.total || this.dataBerusaha.length;
                    } else {
                        this.dataNonBerusaha = processedData;
                        this.totalNonBerusaha = response.data.total || this.dataNonBerusaha.length;
                    }
                }
            } catch (error) {
                console.error(`Gagal memuat data permohonan:`, error);
                this.$toasted.error(`Gagal memuat data permohonan`);
            } finally {
                this.isLoading = false;
            }
        },
        handleDetail(permohonan) {
            const jenis = permohonan.tipe_pemohon === 'Pemerintah' || permohonan.tipe_pemohon === 'Swasta' ? 'nonberusaha' : 'perizinan';
            this.$router.push({ path: `/app/${jenis}/detail-perizinan/${permohonan.id}` });
        },
        async downloadPNG() {
            // Mengambil data URI berformat PNG dari instance chart
            const { imgURI } = await this.$refs.PNBPRevenue.dataURI();

            // Buat elemen <a> virtual untuk mendownload gambar
            const link = document.createElement('a');
            link.href = imgURI;
            link.download = `Chart-PNBP-${this.filterTahun}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        exportToExcel() {
            // 1. Siapkan data dari series/kategori chart Anda
            const categories = this.barChartOptions.xaxis.categories || [];
            // series[0] = nilai bulanan (sebelumnya salah membaca sectorDonutSeries)
            const values = (this.barChartSeries[0] && this.barChartSeries[0].data) || [];

            // Format data menjadi array of objects / array of arrays
            const excelData = categories.map((cat, index) => ({
                Bulan: cat,
                TotalPNBP: values[index]
            }));

            // 2. Buat Worksheet dan Workbook baru
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data Chart");

            // 3. Trigger download file Excel
            XLSX.writeFile(workbook, `Laporan-PNBP-${this.filterTahun}.xlsx`);
        },

        async downloadPNGSektor() {
            try {
                // Pastikan elemen div dengan ref="ChartSektor" sudah ada
                const el = this.$refs.ChartSektor;
                if (!el) {
                    console.error("Elemen wrapper tidak ditemukan");
                    return;
                }

                // Mengambil screenshot dari elemen <div> tersebut
                const canvas = await html2canvas(el, {
                    scale: 2, // Mengatur agar kualitas gambar lebih tajam (High Definition)
                    useCORS: true // Mengatasi masalah gambar/aset luar jika ada
                });

                // Ubah canvas menjadi URL data gambar (PNG)
                const imgURI = canvas.toDataURL('image/png');

                // Buat elemen <a> virtual untuk mendownload gambar
                const link = document.createElement('a');
                link.href = imgURI;
                link.download = `Chart-Sektor-${this.filterTahun}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                console.error("Gagal mendownload elemen HTML:", error);
                alert("Terjadi kesalahan saat mengunduh gambar.");
            }
        },
        exportToExcelSektor() {
            // 1. Siapkan data dari series/kategori chart Anda
            const categories = this.sectorDonutOptions.labels || [];
            const values = this.sectorDonutSeries || [];

            // Format data menjadi array of objects / array of arrays
            const excelData = categories.map((cat, index) => ({
                Nama: cat,
                TotalIzin: values[index]
            }));

            // 2. Buat Worksheet dan Workbook baru
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data Chart");

            // 3. Trigger download file Excel
            XLSX.writeFile(workbook, `Laporan-Sektor-${this.filterTahun}.xlsx`);
        },
        async downloadPNGDistribusiProvinsi() {
            try {
                // Pastikan elemen div dengan ref="ChartDistribusiProvinsi" sudah ada
                const el = this.$refs.ChartDistribusiProvinsi;
                if (!el) {
                    console.error("Elemen wrapper tidak ditemukan");
                    return;
                }

                // Mengambil screenshot dari elemen <div> tersebut
                const canvas = await html2canvas(el, {
                    scale: 2, // Mengatur agar kualitas gambar lebih tajam (High Definition)
                    useCORS: true // Mengatasi masalah gambar/aset luar jika ada
                });

                // Ubah canvas menjadi URL data gambar (PNG)
                const imgURI = canvas.toDataURL('image/png');

                // Buat elemen <a> virtual untuk mendownload gambar
                const link = document.createElement('a');
                link.href = imgURI;
                link.download = `Chart-Distribusi-Provinsi-${this.filterTahun}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                console.error("Gagal mendownload elemen HTML:", error);
                alert("Terjadi kesalahan saat mengunduh gambar.");
            }
        },
        exportToExcelDistribusiProvinsi() {
            // 1. Siapkan data dari series/kategori chart Anda
            const categories = this.provinces || [];
            const values = this.sectorDonutSeries || [];

            // Format data menjadi array of objects / array of arrays
            const excelData = categories.map((cat, index) => ({
                Nama: cat.name,
                TotalIzin: cat.val
            }));

            // 2. Buat Worksheet dan Workbook baru
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data Chart");

            // 3. Trigger download file Excel
            XLSX.writeFile(workbook, `Laporan-Distribusi-Provinsi-${this.filterTahun}.xlsx`);
        },

        getIconConfig(label) {
      if (!label) return { href: '#dp-i-act-0', class: 'dp-act-0' };

      // Cocokan berdasarkan teks label dari response API
      switch (label.trim()) {
        case 'Perizinan Masuk':
          return { href: '#dp-i-act-0', class: 'dp-act-0' };
        case 'Verifikasi Selesai':
          return { href: '#dp-i-act-1', class: 'dp-act-1' };
        case 'Penilaian Teknis':
          return { href: '#dp-i-act-2', class: 'dp-act-2' };
        case 'Izin Diterbitkan':
          return { href: '#dp-i-act-5', class: 'dp-act-5' };
        case 'PNBP dibayar':
          return { href: '#dp-i-act-3', class: 'dp-act-3' };
        case 'Permohonan Ditolak':
          return { href: '#dp-i-act-4', class: 'dp-act-4' };
        default:
          return { href: '#dp-i-act-0', class: 'dp-act-0' };
      }
    }
    },
    watch: {
        filterTahun: {
            handler(val) {
                this.loadDataPermohonan()
                this.fetchDataPermohonan('all');
            },
            immediate: true,
        },

    },
};
</script>

<style>

.dashboard-wrapper {
    --dp-primary: #182d70;
    --dp-blue: #0879df;
    --dp-blue-subtle: #edf6fd;
    --dp-cyan: #06b6d4;
    --dp-green: #10b981;
    --dp-green-subtle: #ecfdf5;
    --dp-green-dark: #047857;
    --dp-purple: #7043d2;
    --dp-purple-subtle: #f5f0ff;
    --dp-red-subtle: #fef2f2;
    --dp-red-dark: #b91c1c;
    --dp-ink: #1e293b;
    --dp-ink-secondary: #475569;
    --dp-muted: #64748b;
    --dp-muted-light: #94a3b8;
    --dp-line: #e2e8f0;
    --dp-panel: #ffffff;
    --dp-radius: 12px;
    --dp-radius-sm: 8px;
    --dp-shadow-sm: 0 1px 2px 0 rgba(16, 24, 40, 0.04);
    --dp-shadow: 0 1px 3px 0 rgba(16, 24, 40, 0.07), 0 1px 2px -1px rgba(16, 24, 40, 0.05);
    --dp-shadow-md: 0 4px 12px -2px rgba(16, 24, 40, 0.08), 0 2px 4px -2px rgba(16, 24, 40, 0.04);

    font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 13.5px;
    line-height: 1.5;
    color: var(--dp-ink);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.dashboard-wrapper .dp-sprite {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
}

.dashboard-wrapper .dp-content {
    display: grid;
    gap: 20px;
    min-width: 0;
}

.dashboard-wrapper .dp-content *,
.dashboard-wrapper .dp-content *::before,
.dashboard-wrapper .dp-content *::after {
    box-sizing: border-box;
}

/* ---------- Ikon ---------- */
.dashboard-wrapper .dp-ic {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.dashboard-wrapper .dp-ic--xs {
    width: 12px;
    height: 12px;
    stroke-width: 2.5;
}

/* ---------- Grid ---------- */
.dashboard-wrapper .dp-grid-3 {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
}

.dashboard-wrapper .dp-two-col {
    display: grid;
    grid-template-columns: minmax(320px, 380px) minmax(0, 1fr);
    gap: 20px;
}

.dashboard-wrapper .dp-bottom-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

/* ---------- Kartu ---------- */
.dashboard-wrapper .dp-card {
    min-width: 0;
    background: var(--dp-panel);
    border: 1px solid var(--dp-line);
    border-radius: var(--dp-radius);
    box-shadow: var(--dp-shadow);
    padding: 20px;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.dashboard-wrapper .dp-card:hover {
    box-shadow: var(--dp-shadow-md);
    border-color: #cbd5e1;
}

.dashboard-wrapper .dp-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.dashboard-wrapper .dp-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: -0.2px;
}

.dashboard-wrapper .dp-card-title-icon {
    display: flex;
    align-items: center;
    color: var(--dp-blue);
}

.dashboard-wrapper .dp-card-title-icon .dp-ic {
    width: 18px;
    height: 18px;
}

.dashboard-wrapper .dp-desc {
    font-size: 12px;
    color: var(--dp-muted);
    margin-top: 1px;
}

.dashboard-wrapper .dp-small {
    font-size: 12px;
}

.dashboard-wrapper .dp-muted {
    color: var(--dp-muted);
}

.dashboard-wrapper .dp-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ---------- Metrik ---------- */
.dashboard-wrapper .dp-metric-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 12px 0 16px;
}

.dashboard-wrapper .dp-metric-left {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
}

.dashboard-wrapper .dp-metric-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.dashboard-wrapper .dp-metric-icon .dp-ic {
    width: 22px;
    height: 22px;
}

.dashboard-wrapper .dp-metric-icon--blue {
    color: var(--dp-blue);
    background: var(--dp-blue-subtle);
}

.dashboard-wrapper .dp-metric-icon--purple {
    color: var(--dp-purple);
    background: var(--dp-purple-subtle);
}

.dashboard-wrapper .dp-metric-icon--green {
    color: var(--dp-green);
    background: var(--dp-green-subtle);
}

.dashboard-wrapper .dp-metric-value-wrap {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}

.dashboard-wrapper .dp-metric {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.6px;
    line-height: 1.15;
    color: #0f172a;
}

.dashboard-wrapper .dp-metric-sub {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    border-radius: 6px;
    padding: 3px 8px;
    font-size: 12px;
    font-weight: 500;
}

.dashboard-wrapper .dp-metric-sub--negative {
    color: var(--dp-red-dark);
    background: var(--dp-red-subtle);
}

.dashboard-wrapper .dp-metric-sub--positive {
    color: var(--dp-green-dark);
    background: var(--dp-green-subtle);
}

/* ---------- Donut mini (SVG) ---------- */
.dashboard-wrapper .dp-mini-donut {
    position: relative;
    width: 58px;
    height: 58px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dashboard-wrapper .dp-mini-donut svg {
    width: 58px;
    height: 58px;
    transform: rotate(-90deg);
}

.dashboard-wrapper .dp-donut-bg {
    fill: none;
    stroke: #f1f5f9;
    stroke-width: 6;
}

.dashboard-wrapper .dp-donut-bar {
    fill: none;
    stroke-width: 6;
    stroke-linecap: round;
    transition: stroke-dasharray 0.5s ease, stroke-dashoffset 0.5s ease;
}

.dashboard-wrapper .dp-donut-bar--blue {
    stroke: var(--dp-blue);
}

.dashboard-wrapper .dp-donut-bar--green {
    stroke: var(--dp-green);
}

.dashboard-wrapper .dp-donut-bar--cyan {
    stroke: var(--dp-cyan);
}

.dashboard-wrapper .dp-donut-center {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: var(--dp-ink);
    line-height: 1.1;
    pointer-events: none;
}

.dashboard-wrapper .dp-donut-val {
    font-size: 13.5px;
    font-weight: 700;
    color: var(--dp-ink);
    line-height: 1.1;
}

.dashboard-wrapper .dp-donut-sub {
    font-size: 9.5px;
    font-weight: 500;
    color: var(--dp-muted);
    line-height: 1;
    margin-top: 1px;
}

.dashboard-wrapper .dp-donut-center--single {
    font-size: 11px;
}

/* ---------- Segmen (Berusaha / Pemerintah / Swasta ...) ---------- */
.dashboard-wrapper .dp-segment-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-top: 14px;
    border: 1px solid var(--dp-line);
    border-radius: var(--dp-radius-sm);
    overflow: hidden;
    background: #fafbfc;
}

.dashboard-wrapper .dp-segment-row--2 {
    grid-template-columns: repeat(2, 1fr);
}

.dashboard-wrapper .dp-segment {
    appearance: none;
    -webkit-appearance: none;
    margin: 0;
    background: transparent;
    border: 0;
    border-right: 1px solid var(--dp-line);
    font: inherit;
    cursor: pointer;
    padding: 10px 8px;
    text-align: center;
    font-size: 12px;
    color: var(--dp-ink-secondary);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    transition: background 0.15s ease;
    min-width: 0;
}

.dashboard-wrapper .dp-segment:last-child {
    border-right: 0;
}

.dashboard-wrapper .dp-segment:hover {
    background: #f1f5f9;
}

.dashboard-wrapper .dp-segment-label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
    font-size: 12px;
    color: var(--dp-muted);
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dashboard-wrapper .dp-segment strong {
    font-size: 14px;
    font-weight: 700;
    color: var(--dp-ink);
}

.dashboard-wrapper .dp-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.dashboard-wrapper .dp-dot--blue {
    background: var(--dp-blue);
}

.dashboard-wrapper .dp-dot--green {
    background: var(--dp-green);
}

.dashboard-wrapper .dp-dot--cyan {
    background: var(--dp-cyan);
}

.dashboard-wrapper .dp-link-btn {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    padding: 0;
    margin: 0;
    background: transparent;
    font: inherit;
    color: var(--dp-blue);
    font-weight: 600;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    cursor: pointer;
    transition: color 0.15s ease;
}

.dashboard-wrapper .dp-link-btn:hover,
.dashboard-wrapper .dp-segment:hover .dp-link-btn {
    color: #0369a1;
    text-decoration: underline;
}

/* ---------- Filter bulan PNBP & select umum ---------- */
.dashboard-wrapper .dp-pnbp-select,
.dashboard-wrapper .dp-select-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.dashboard-wrapper .dp-pnbp-select select {
    appearance: none;
    -webkit-appearance: none;
    background: #f1f5f9;
    border: 1px solid var(--dp-line);
    border-radius: 6px;
    padding: 3px 22px 3px 9px;
    font: inherit;
    font-size: 12px;
    font-weight: 500;
    color: var(--dp-ink-secondary);
    cursor: pointer;
    outline: none;
    line-height: 1.4;
    height: auto;
    transition: all 0.15s ease;
    max-width: 230px;
}

.dashboard-wrapper .dp-pnbp-select select:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: var(--dp-ink);
}

.dashboard-wrapper .dp-pnbp-select select:focus {
    border-color: var(--dp-purple);
    box-shadow: 0 0 0 2px rgba(112, 67, 210, 0.15);
    background: #fff;
}

.dashboard-wrapper .dp-pnbp-select-arrow {
    position: absolute;
    right: 6px;
    pointer-events: none;
    color: var(--dp-muted);
    display: flex;
    align-items: center;
}

.dashboard-wrapper .dp-select {
    appearance: none;
    -webkit-appearance: none;
    border: 1px solid #cbd5e1;
    border-radius: var(--dp-radius-sm);
    background: #fff;
    padding: 6px 30px 6px 12px;
    font: inherit;
    font-size: 12.5px;
    font-weight: 500;
    color: var(--dp-ink);
    outline: none;
    cursor: pointer;
    box-shadow: var(--dp-shadow-sm);
    line-height: 1.4;
    height: auto;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.dashboard-wrapper .dp-select:focus {
    border-color: var(--dp-blue);
    box-shadow: 0 0 0 3px rgba(8, 121, 223, 0.15);
}

.dashboard-wrapper .dp-select-arrow {
    position: absolute;
    right: 10px;
    pointer-events: none;
    color: var(--dp-muted);
    display: flex;
    align-items: center;
}

/* Tombol menu unduh (b-dropdown) */
.dashboard-wrapper .dp-icon-btn.btn {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--dp-ink-secondary);
    background: #fff;
    border: 1px solid var(--dp-line);
    border-radius: var(--dp-radius-sm);
    box-shadow: var(--dp-shadow-sm);
}

.dashboard-wrapper .dp-icon-btn.btn:hover,
.dashboard-wrapper .dp-icon-btn.btn:focus,
.dashboard-wrapper .dp-icon-btn.btn:active {
    color: var(--dp-primary);
    background: #f8fafc;
    border-color: #cbd5e1;
    box-shadow: var(--dp-shadow-sm);
}

.dashboard-wrapper .dp-icon-btn .dp-ic {
    width: 16px;
    height: 16px;
}

/* ---------- Progres PNBP ---------- */
.dashboard-wrapper .dp-progress-wrap {
    margin: 10px 0 6px;
}

.dashboard-wrapper .dp-progress-label {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: var(--dp-muted);
    margin-bottom: 5px;
}

.dashboard-wrapper .dp-progress-label b {
    color: var(--dp-ink);
    font-weight: 600;
}

.dashboard-wrapper .dp-progress {
    height: 6px;
    border-radius: 10px;
    background: #edf2f7;
    overflow: hidden;
}

.dashboard-wrapper .dp-progress span {
    display: block;
    height: 100%;
    background: var(--dp-blue);
    border-radius: inherit;
    transition: width 0.5s ease;
}

.dashboard-wrapper .dp-card-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
}

/* ---------- Alur proses bisnis ---------- */
.dashboard-wrapper .dp-process-card {
    padding: 22px;
}

.dashboard-wrapper .dp-process-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
    flex-wrap: wrap;
}

.dashboard-wrapper .dp-conversion-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid var(--dp-line);
    border-radius: 20px;
    padding: 5px 12px;
    background: #f8fafc;
    color: var(--dp-ink-secondary);
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.dashboard-wrapper .dp-conversion-badge strong {
    color: var(--dp-blue);
    font-weight: 700;
}

.dashboard-wrapper .dp-stages {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
}

.dashboard-wrapper .dp-stage {
    border: 1px solid var(--dp-line);
    border-radius: 10px;
    padding: 14px 12px;
    min-width: 0;
    position: relative;
    background: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: var(--dp-shadow-sm);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.dashboard-wrapper .dp-stage:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 0 2px rgba(8, 121, 223, 0.2), var(--dp-shadow-md);
    border-color: var(--dp-blue);
}

.dashboard-wrapper .dp-stage-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.dashboard-wrapper .dp-stage-num {
    color: var(--dp-stage-color, var(--dp-blue));
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.5px;
}

.dashboard-wrapper .dp-stage-step {
    font-size: 11px;
    font-weight: 500;
    padding: 2px 6px;
    border-radius: 4px;
    background: #f1f5f9;
    color: var(--dp-muted);
}

.dashboard-wrapper .dp-stage h3 {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.3;
    margin: 0 0 6px;
    min-height: 34px;
}

.dashboard-wrapper .dp-count-wrap {
    margin: 4px 0 10px;
}

.dashboard-wrapper .dp-count {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: #0f172a;
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
}

.dashboard-wrapper .dp-count-label {
    font-size: 12px;
    color: var(--dp-muted);
    font-weight: 400;
}

.dashboard-wrapper .dp-stage-progress {
    height: 5px;
    border-radius: 10px;
    background: #f1f5f9;
    overflow: hidden;
    margin-bottom: 12px;
    cursor: pointer;
    outline: none;
}

.dashboard-wrapper .dp-stage-progress span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: var(--dp-stage-color, var(--dp-blue));
    transition: width 0.25s ease, filter 0.15s ease;
}

.dashboard-wrapper .dp-stage-progress:hover span,
.dashboard-wrapper .dp-stage-progress:focus-visible span,
.dashboard-wrapper .dp-stage-progress.is-selected span {
    filter: brightness(1.1);
}

.dashboard-wrapper .dp-stage-progress:focus-visible {
    box-shadow: 0 0 0 3px rgba(8, 121, 223, 0.18);
}

.dashboard-wrapper .dp-stage-progress-info {
    display: none;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin: -4px 0 10px;
    padding: 5px 8px;
    border-radius: 6px;
    background: #f1f5f9;
    background: color-mix(in srgb, var(--dp-stage-color, var(--dp-blue)) 10%, white);
    color: var(--dp-ink-secondary);
    font-size: 11px;
}

.dashboard-wrapper .dp-stage-progress-info strong {
    color: var(--dp-stage-color, var(--dp-blue));
    font-size: 12px;
}

.dashboard-wrapper .dp-stage-progress-info.is-shown {
    display: flex;
}

.dashboard-wrapper .dp-stage-details {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: auto;
    border-top: 1px dashed var(--dp-line);
    padding-top: 10px;
}

.dashboard-wrapper .dp-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--dp-muted);
}

.dashboard-wrapper .dp-detail b {
    color: var(--dp-ink);
    font-weight: 600;
}

.dashboard-wrapper .dp-detail b.is-green {
    color: #059669;
}

.dashboard-wrapper .dp-detail b.is-red {
    color: #dc2626;
}

/* ---------- Aktivitas ---------- */
.dashboard-wrapper .dp-live-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #fff;
    background: #ef4444;
    padding: 3px 8px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
}

.dashboard-wrapper .dp-live-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    animation: dp-pulse 1.8s infinite;
}

@keyframes dp-pulse {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.4;
        transform: scale(0.8);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.dashboard-wrapper .dp-activity-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 14px;
}

.dashboard-wrapper .dp-activity {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 9px 12px;
    font-size: 12.5px;
    color: var(--dp-ink-secondary);
    border-radius: var(--dp-radius-sm);
    background: #f8fafc;
    border: 1px solid #f1f5f9;
    transition: background 0.15s ease;
}

.dashboard-wrapper .dp-activity:hover {
    background: #f1f5f9;
}

.dashboard-wrapper .dp-activity-left {
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
}

.dashboard-wrapper .dp-activity-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.dashboard-wrapper .dp-activity-icon .dp-ic {
    width: 14px;
    height: 14px;
}

.dashboard-wrapper .dp-act-0 {
    background: #e0f2fe;
    color: #0369a1;
}

.dashboard-wrapper .dp-act-1 {
    background: #dcfce7;
    color: #15803d;
}

.dashboard-wrapper .dp-act-2 {
    background: #f3e8ff;
    color: #7e22ce;
}

.dashboard-wrapper .dp-act-3 {
    background: #fef3c7;
    color: #b45309;
}

.dashboard-wrapper .dp-act-4 {
    background: #fee2e2;
    color: #b91c1c;
}

.dashboard-wrapper .dp-act-5 {
    background: #ecfdf5;
    color: #047857;
}

.dashboard-wrapper .dp-badge-count {
    padding: 2px 8px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--dp-line);
    color: var(--dp-muted);
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
}

.dashboard-wrapper .dp-badge-count.is-active {
    background: var(--dp-green-subtle);
    border-color: #a7f3d0;
    color: var(--dp-green-dark);
}

/* ---------- Grafik PNBP ---------- */
.dashboard-wrapper .dp-chart-box {
    margin-top: 6px;
    min-height: 200px;
}

/* ---------- Sektor ---------- */
.dashboard-wrapper .dp-sector-layout {
    display: grid;
    grid-template-columns: 140px minmax(0, 1fr);
    gap: 20px;
    align-items: center;
    margin-top: 16px;
}

.dashboard-wrapper .dp-pie-wrapper {
    position: relative;
    width: 140px;
    height: 140px;
    margin: auto;
    flex-shrink: 0;
}

.dashboard-wrapper .dp-legend {
    display: grid;
    gap: 7px;
}

.dashboard-wrapper .dp-legend-row {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    border-radius: 5px;
    padding: 3px;
    margin: -3px;
    transition: background 0.15s ease;
}

.dashboard-wrapper .dp-legend-row:hover {
    background: #f1f5f9;
}

.dashboard-wrapper .dp-legend-name {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    color: var(--dp-ink-secondary);
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dashboard-wrapper .dp-legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

.dashboard-wrapper .dp-legend-count {
    color: var(--dp-muted);
    font-weight: 500;
}

.dashboard-wrapper .dp-legend-percent {
    color: var(--dp-ink);
    font-weight: 600;
    min-width: 40px;
    text-align: right;
}

.dashboard-wrapper .dp-legend-line {
    height: 3px;
    border-radius: 3px;
    background: #f1f5f9;
    grid-column: 1 / -1;
    margin-top: 1px;
    overflow: hidden;
}

.dashboard-wrapper .dp-legend-line span {
    display: block;
    height: 100%;
    background: var(--dp-blue);
}

/* ---------- Provinsi ---------- */
.dashboard-wrapper .dp-province-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    max-height: 200px;
    overflow-y: auto;
}

.dashboard-wrapper .dp-province {
    display: grid;
    grid-template-columns: 24px 130px minmax(0, 1fr) 30px;
    gap: 10px;
    align-items: center;
    font-size: 12px;
}

.dashboard-wrapper .dp-rank {
    color: var(--dp-muted-light);
    font-weight: 600;
    font-size: 12px;
}

.dashboard-wrapper .dp-name {
    font-weight: 500;
    color: var(--dp-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dashboard-wrapper .dp-track {
    height: 8px;
    border-radius: 10px;
    background: #f1f5f9;
    overflow: hidden;
}

.dashboard-wrapper .dp-track span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #0879df 0%, #0879df 100%);
}

.dashboard-wrapper .dp-number {
    text-align: right;
    font-weight: 600;
    color: var(--dp-ink);
}

/* ---------- Tabel PKPN ---------- */
.dashboard-wrapper .dp-table-card {
    padding: 22px;
}

.dashboard-wrapper .dp-table-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

/* b-tabs (pills) tampil seperti tombol segmen "Berusaha | Non Berusaha" */
.dashboard-wrapper .dp-switch-tabs .nav-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 16px 0 14px;
    padding: 0;
}

.dashboard-wrapper .dp-switch-tabs .nav-pills .nav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--dp-line);
    border-radius: var(--dp-radius-sm);
    background: #f8fafc;
    padding: 7px 14px;
    color: var(--dp-ink-secondary);
    font-size: 12.5px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.dashboard-wrapper .dp-switch-tabs .nav-pills .nav-link:hover {
    background: #f1f5f9;
    color: var(--dp-ink);
}

.dashboard-wrapper .dp-switch-tabs .nav-pills .nav-link.active,
.dashboard-wrapper .dp-switch-tabs .nav-pills .nav-link.dp-switch-active {
    background: var(--dp-primary);
    color: #fff;
    border-color: var(--dp-primary);
    box-shadow: 0 2px 8px rgba(24, 45, 112, 0.2);
}

.dashboard-wrapper .dp-switch-count {
    background: rgba(0, 0, 0, 0.08);
    padding: 1px 7px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
}

.dashboard-wrapper .dp-switch-tabs .nav-link.active .dp-switch-count,
.dashboard-wrapper .dp-switch-tabs .nav-link.dp-switch-active .dp-switch-count {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
}

/*
  Tabel di dalam TabelPermohonanPKPN: selector umum (table/thead/th/td). Bila komponen anak memakai b-table atau kelas
  sendiri, tampilan dasarnya ikut berubah; status badge dan tombol Detail perlu kelas tambahan di komponen anak
  (.dp-status-badge, .dp-status-dot, .dp-detail-btn di bawah).
*/
.dashboard-wrapper .dp-table-scope {
    overflow-x: auto;
    border: 1px solid var(--dp-line);
    border-radius: var(--dp-radius-sm);
}

.dashboard-wrapper .dp-table-scope table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
    font-size: 12.5px;
    text-align: left;
}

.dashboard-wrapper .dp-table-scope thead {
    background: #f8fafc;
}

.dashboard-wrapper .dp-table-scope thead th {
    background: #f8fafc;
    font-weight: 600;
    color: var(--dp-ink-secondary);
    padding: 12px 14px;
    white-space: nowrap;
    font-size: 12px;
    letter-spacing: 0.1px;
    border: 0;
    border-bottom: 1px solid var(--dp-line);
    vertical-align: middle;
}

.dashboard-wrapper .dp-table-scope tbody td {
    padding: 12px 14px;
    border: 0;
    border-bottom: 1px solid #f1f5f9;
    color: var(--dp-ink);
    vertical-align: middle;
    background: transparent;
}

.dashboard-wrapper .dp-table-scope tbody tr:last-child td {
    border-bottom: 0;
}

.dashboard-wrapper .dp-table-scope tbody tr {
    transition: background 0.15s ease;
}

.dashboard-wrapper .dp-table-scope tbody tr:hover {
    background-color: #f8fafc;
}

.dashboard-wrapper .dp-table-scope .table-striped tbody tr:nth-of-type(odd) {
    background-color: transparent;
}

.dashboard-wrapper .dp-table-scope .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #f8fafc;
}

.dashboard-wrapper .dp-table-scope tbody td:first-child {
    font-weight: 500;
    color: var(--dp-primary);
}

.dashboard-wrapper .dp-table-scope .pagination {
    gap: 4px;
}

.dashboard-wrapper .dp-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #fef3c7;
    color: #92400e;
    border-radius: 20px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.dashboard-wrapper .dp-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f59e0b;
}

.dashboard-wrapper .dp-detail-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #cbd5e1;
    background: #fff;
    border-radius: 6px;
    color: var(--dp-primary);
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.dashboard-wrapper .dp-detail-btn:hover {
    background: #f1f5f9;
    border-color: var(--dp-primary);
}

/* ---------- Fokus keyboard ---------- */
.dashboard-wrapper .dp-stage:focus-visible,
.dashboard-wrapper .dp-segment:focus-visible,
.dashboard-wrapper .dp-link-btn:focus-visible,
.dashboard-wrapper .dp-select:focus-visible {
    outline: 3px solid rgba(8, 121, 223, 0.35);
    outline-offset: 2px;
}

/* ---------- Responsif ---------- */
@media (min-width: 1440px) {
    .dashboard-wrapper .dp-two-col {
        grid-template-columns: 380px minmax(0, 1fr);
        gap: 24px;
    }

    .dashboard-wrapper .dp-bottom-grid {
        gap: 24px;
    }

    .dashboard-wrapper .dp-sector-layout {
        grid-template-columns: 160px minmax(0, 1fr);
        gap: 28px;
    }

    .dashboard-wrapper .dp-pie-wrapper {
        width: 155px;
        height: 155px;
    }

    .dashboard-wrapper .dp-legend {
        grid-template-columns: 1fr 1fr;
        gap: 10px 20px;
    }

    .dashboard-wrapper .dp-province {
        grid-template-columns: 28px 140px minmax(0, 1fr) 36px;
        gap: 12px;
        font-size: 12.5px;
    }

    .dashboard-wrapper .dp-track {
        height: 9px;
    }
}

@media (min-width: 1800px) {
    .dashboard-wrapper .dp-content {
        gap: 24px;
    }

    .dashboard-wrapper .dp-grid-3 {
        gap: 24px;
    }

    .dashboard-wrapper .dp-two-col {
        grid-template-columns: 420px minmax(0, 1fr);
        gap: 24px;
    }

    .dashboard-wrapper .dp-stages {
        gap: 16px;
    }

    .dashboard-wrapper .dp-stage {
        padding: 16px 14px;
    }

    .dashboard-wrapper .dp-sector-layout {
        grid-template-columns: 180px minmax(0, 1fr);
        gap: 32px;
    }

    .dashboard-wrapper .dp-pie-wrapper {
        width: 170px;
        height: 170px;
    }

    .dashboard-wrapper .dp-legend {
        gap: 12px 24px;
    }
}

@media (max-width: 1280px) {
    .dashboard-wrapper .dp-two-col {
        grid-template-columns: 320px minmax(0, 1fr);
    }

    .dashboard-wrapper .dp-stages {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 1024px) {
    .dashboard-wrapper .dp-grid-3 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dashboard-wrapper .dp-grid-3>.dp-card:last-child {
        grid-column: span 2;
    }

    .dashboard-wrapper .dp-two-col,
    .dashboard-wrapper .dp-bottom-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .dashboard-wrapper .dp-grid-3 {
        grid-template-columns: 1fr;
    }

    .dashboard-wrapper .dp-grid-3>.dp-card:last-child {
        grid-column: auto;
    }

    .dashboard-wrapper .dp-stages {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dashboard-wrapper .dp-sector-layout {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px) {
    .dashboard-wrapper .dp-card {
        padding: 16px;
    }

    .dashboard-wrapper .dp-stages {
        grid-template-columns: 1fr;
    }

    .dashboard-wrapper .dp-province {
        grid-template-columns: 20px 105px minmax(0, 1fr) 24px;
    }
}

/* ---------- Tooltip grafik PNBP (apexchart, tooltip.custom di script) ---------- */
/* Pembungkus bawaan apexchart dibuat transparan; kartu gelapnya digambar oleh .dp-tt. */
.dashboard-wrapper .dp-chart-box .apexcharts-tooltip {
    background: transparent;
    border: 0;
    box-shadow: none;
    overflow: visible;
}

.dashboard-wrapper .dp-tt {
    min-width: 128px;
    padding: 8px 10px;
    border: 1px solid #dbeafe;
    border-radius: 7px;
    background: #0f172a;
    color: #ffffff;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.2);
    font-family: inherit;
    line-height: 1.3;
}

.dashboard-wrapper .dp-tt-month,
.dashboard-wrapper .dp-tt-amount,
.dashboard-wrapper .dp-tt-cum {
    display: block;
}

.dashboard-wrapper .dp-tt-month {
    color: #cbd5e1;
    font-size: 11px;
    font-weight: 500;
}

.dashboard-wrapper .dp-tt-amount {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 700;
}

.dashboard-wrapper .dp-tt-cum {
    margin-top: 3px;
    color: #bfdbfe;
    font-size: 10px;
}

.info-circle-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #0879df; /* Warna latar belakang biru */
    color: #ffffff;            /* Warna ikon putih agar kontras */
    border-radius: 50%;        /* Membuat elemen menjadi lingkaran sempurna */
    font-size: 10px;           /* Ukuran ikon di dalam lingkaran */
    cursor: pointer;
    transition: filter 0.15s ease;
}

.info-circle-icon:hover {
    filter: brightness(1.1);   /* Efek sedikit lebih terang saat di-hover */
}
</style>